import { Injectable } from '@angular/core';
import { ITutorial } from './tutorial-if';
import { filter, delay } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
declare var $;
import { TutorialStaticProps } from './turorial-static-props';
import { TutorialHttpLogService } from './tutorial-http.service';

/** 認証処理・トークンやサインイン中の社員に関連する情報を保持し続けるためのService */
@Injectable()
export class TutorialKeepPropService {
  constructor(
    private http: TutorialHttpLogService,
  ) {}

  /** チュートリアルを開始 */
  public show(steps: ITutorial.Step[]): void {
    TutorialStaticProps.steps = steps;
    TutorialStaticProps.tutorialTitle = steps[0].tutorialTitle;
    TutorialStaticProps.currentStep = 0;
    TutorialStaticProps.running = true;
    this.renderTutorialArea();
    this.http.createWebInstructionsClickLog().subscribe(
      ok => {},
      err => {},
    );
    this.next();
  }

  /** チュートリアルを終了 */
  private hide(): void {
    if (TutorialStaticProps.running) {
      this.removeStepNoElement();
      $('app-tutorial #tutorial-description-area').animate({
        bottom: '-234px',
        opacity: 0,
      }, 400, 'swing', () => {
        $('app-tutorial #tutorial-description-area').css({ display: 'none' });
      });
      TutorialStaticProps.running = false;
    }
    if (TutorialStaticProps.subObserveStepNoElement && !TutorialStaticProps.subObserveStepNoElement.closed) { TutorialStaticProps.subObserveStepNoElement.unsubscribe(); }
  }

  public renderTutorialArea(renderType: 'immidiately' = null): void {
    if (TutorialStaticProps.running) {
      this.removeStepNoElement();
    }
    $('app-tutorial #tutorial-description-area').css({
      display: 'block',
      opacity: 0,
    });
    if (renderType === 'immidiately') {
      $('app-tutorial #tutorial-description-area').css({ bottom: 0 });
    } else {
      $('app-tutorial #tutorial-description-area').animate({
        bottom: 0,
        opacity: 1,
      }, 400, 'swing');
    }
  }

  private resizeHeight(step: ITutorial.Step): void {
    if (step.changeHeight) {
      TutorialStaticProps.customHeight = step.changeHeight;
    } else {
      TutorialStaticProps.customHeight = TutorialStaticProps.DEFAULT_CUSTOM_HEIGHT;
    }
  }

  /** 次のステップへ */
  public next(value = 1): void {
    if (TutorialStaticProps.currentStep + 1 > TutorialStaticProps.steps.length) {
      this.complete();
      return;
    }
    TutorialStaticProps.currentStep += value;
    this.resizeHeight(TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1]);
    this.removeStepNoElement();
    this.observeRenderingStepNo();
  }

  /** 前のステップへ */
  public prev(value = 1): void {
    if (TutorialStaticProps.currentStep - 1 > TutorialStaticProps.steps.length) {
      this.hide();
      return;
    }
    TutorialStaticProps.currentStep -= value;
    this.resizeHeight(TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1]);
    this.removeStepNoElement();
    this.observeRenderingStepNo();
  }

  /** チュートリアル中断 */
  public cancel(): void {
    this.hide();
  }

  private complete(): void {
    this.hide();
    // IntroQuestionnaireService.openModal();
  }

  /** ステップNOを描写 */
  public observeRenderingStepNo(): void {
    if (TutorialStaticProps.subObserveStepNoElement && !TutorialStaticProps.subObserveStepNoElement.closed) { TutorialStaticProps.subObserveStepNoElement.unsubscribe(); }
    TutorialStaticProps.subObserveStepNoElement = TutorialStaticProps.observeStepNoElement$
      // ステップNOを表示するHTML要素が存在するかチェック
      .pipe(
        filter(targetElement => targetElement && !!targetElement[0] && targetElement.is(':visible')),
        delay(300)  // 即時にステップNOを描写すると、ターゲット要素がまだ画面表示されきっていない場合にズレるので、少し待たせる
      )
      .subscribe(
        tagetElement => {
          // 以降の処理を実行する前にdelay()でウェイトしている為、ターゲット要素が存在しない可能性があるのでチェックする
          if (!$(`${TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].targetElementId}`) ||
              !$(`${TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].targetElementId}`)[0] ||
              !$(`${TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].targetElementId}`).is(':visible')) {
            return;
          }
          // 存在した場合はbody要素にステップNOを描写
          this.createNewStepNoElement();
          this.scrollToElement();
          TutorialStaticProps.subObserveStepNoElement.unsubscribe();
        }
    );
  }

  private createNewStepNoElement(): void {
    const baseElement = !!TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].parentModalId ? TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].parentModalId : 'html, body';
    $(baseElement).first().append(`
      <div id="tutorial-step-no-dynamic">
        <div class="number">${TutorialStaticProps.currentStep}</div>
      </div>
    `);
    const offset = $(`${TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].targetElementId}`).offset();
    // ターゲット要素がモーダルの子要素の場合は、モーダルのscrollTopを加算
    if (!!TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].parentModalId) {
      offset.top += $(TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].parentModalId).scrollTop();
      offset.top -= $('html, body').scrollTop();
    }
    // ステップNOの絶対座標を指定
    const correctionTop: number = TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].correctionTopPx ? TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].correctionTopPx : 0;
    const correctionLeft: number = TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].correctionLeftPx ? TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].correctionLeftPx : 0;
    $('#tutorial-step-no-dynamic').css({
      'top': `${offset.top - 20 + correctionTop}px`,
      'left': `${offset.left - 20 + correctionLeft}px`,
    });
  }

  private scrollToElement(): void {
    const scrollableElementId = !!TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].parentModalId ? TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].parentModalId : 'html,body';

    //const target = '#' + $(this).html();
    const scrollPos = $(TutorialStaticProps.steps[TutorialStaticProps.currentStep - 1].targetElementId).offset().top - 200;
    $(scrollableElementId).animate({scrollTop: scrollPos}, 'slow', 'swing');
  }

  private removeStepNoElement(): void {
    if (!!$(`#tutorial-step-no-dynamic`)[0]) {
      $(`#tutorial-step-no-dynamic`).remove();
    }
    if (!!$(`app-tutorial #tutorial-step-no-dynamic:hidden`)[0]) {
      $(`#tutorial-step-no-dynamic:hidden`).remove();
    }
  }
}
